import React from 'react';

import { Status } from '@ariksa/notification/api';
import { Text, Wrap, WrapItem } from '@chakra-ui/react';
import map from 'lodash/map';

export const ticketStatusOptions = [
  { label: 'State', value: undefined },
  { label: 'To do', value: Status.Active },
  { label: 'In progress', value: Status.InProgress },
  { label: 'Done', value: Status.Resolved },
];

export const overDueFilterOptions = [
  { label: 'Over SLA', value: true },
  {
    label: 'Not Over SLA',
    value: false,
  },
];

export const renderStatusOfChildTickets = (ticket: any) => {
  const childTickets = map(
    ticket?.child_ticket_status_counts,
    (count, key) => ({ key, count }),
  );
  return (
    <Wrap>
      {map(childTickets, (o, index) => (
        <WrapItem>
          <Text>
            {`${o.key} (${o.count})${
              index < childTickets.length - 1 ? ', ' : ''
            }`}
          </Text>
        </WrapItem>
      ))}
    </Wrap>
  );
};
